import type { ButtonHTMLAttributes, PropsWithChildren } from "react";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: "primary" | "neutral" | "danger";
}

export const Button = ({
  children,
  tone = "neutral",
  type = "button",
  ...props
}: PropsWithChildren<ButtonProps>) => (
  <button type={type} data-tone={tone} {...props}>
    {children}
  </button>
);
